export function isClient() {
  if (typeof window !== 'undefined') {
    return true;
  }
  return false;
}

export function isBannerPlatform(platform) {
  const bannerPlatforms = ['iPhone', 'iPod', 'iPad', 'Android'];
  if (bannerPlatforms.indexOf(platform) !== -1) {
    return true;
  }
  return false;
}

const initBranch = () => new Promise((resolve, reject) => {
  require('branch-sdk').default;
  const configData = JSON.parse(document.getElementById('configData').textContent);
  const branchKey = configData.analytics.branch;
  window.branch.init(branchKey, {
    no_journeys: __DEV__ ? true : false
  }, (err, data) => {
    if (err) {
      reject(err);
      return;
    }
    resolve(window.branch);
  });
});

const getBranch = async () => {
  if (isClient()) {
    if (typeof window.branch !== 'undefined') {
      // Branch has been initialised already
      return window.branch;
    }
    return await initBranch();
  }
  return false;
};

const expectJourney = async (callback) => {
  const branch = await getBranch();
  if (branch) {
    branch.addListener('willShowJourney', (resp) => callback(true));
    branch.addListener('willNotShowJourney', (resp) => callback(false));
  }
}

const stopExpectingJourney = async () => {
  const branch = await getBranch();
  if (branch) {
    branch.removeListener('willShowJourney');
    branch.removeListener('willNotShowJourney');
  }
}

const sendSMS = async (number, deeplink, referrer, callback) => {
  const branch = await getBranch();

  if (branch) {
    branch.sendSMS(number, {
      data: {
        '$deeplink_path': deeplink,
        'referring_user': referrer,
      },
    }, {
      make_new_link: true,
    }, callback);
  }
};

const createLink = async (linkPath, refer, params, callback) => {
  const branch = await getBranch();

  if (params.$canonical_url === undefined
  || linkPath === undefined
  ) {
    return false;
  }

  if (branch) {
    branch.link({
      ...params,
      data: {
        'referring_user': refer,
        '$deeplink_path': linkPath,
        'referringURL': params.$canonical_url,
        'branch_channel': params.channel,
        'username': refer,
      },
    }, function(err, link) {
      if (link) {
        callback(link);
        return true;
      }
      console.error(err);
      return false;
    });
  }
};

export {
  sendSMS,
  createLink,
  expectJourney,
  stopExpectingJourney
};



// WEBPACK FOOTER //
// ../src/client/utils/deeplinks.js